export type AppliaPillarOneRouteNarrative =
	| "Energy"	
	| "Production"
	| "Material flow"
	| "Use & consumption"
	| "Repair"
	| "Recycling"
	| "Secondary raw materials";
export type AppliaPillarTwoRouteNarrative = "Market trends" | "R&D";

export type AppliaPillarNarrative = AppliaPillarOneRouteNarrative | AppliaPillarTwoRouteNarrative;

export interface AppliaRoute {
	label: string;
	description?: string;
	children?: AppliaChildRoute[];
	pathName?: string;
	url?: string;
	pillarNumber?: number;
}

export interface AppliaChildRoute extends Omit<AppliaRoute, "children" | "pillarNumber"> {
	url: string;
	narrative?: AppliaPillarOneRouteNarrative | AppliaPillarTwoRouteNarrative;
}

export interface AppliaSiblingRoute {
	label: string;
	url: string;
	pillarNumber?: number;
	pathName?: string;
}

export const routes: AppliaRoute[] = [
	{
		label: "navigation.introduction.index",
		pathName: "introduction",
		children: [
			{
				url: "/about-applia",
				label: "navigation.introduction.aboutApplia",
				description: "pages.introduction.aboutApplia.heroIntro",
			},
			{
				url: "/foreword",
				label: "navigation.introduction.foreword",
				description: "pages.introduction.foreword.heroIntro",
			},
			{
				url: "/applia-direct-members",
				label: "navigation.introduction.appliaDirectMembers",
				description: "pages.introduction.appliaDirectMembers.heroIntro",
			},
			{
				url: "/become-a-member",
				label: "navigation.introduction.becomeAMember",
				description: "pages.introduction.becomeAMember.heroIntro",
			},
			{
				url: "/national-associations",
				label: "navigation.introduction.nationalAssociations",
				description: "pages.introduction.nationalAssociations.heroIntro",
			},
			{
				url: "/irhma",
				label: "navigation.introduction.irhma",
				description: "pages.introduction.irhma.heroIntro",
			},
			{
				url: "/applia-secretariat",
				label: "navigation.introduction.appliaSecretariat",
				description: "pages.introduction.appliaSecretariat.intro",
			},
			{
				url: "/home-appliance-industry-in-europe",
				label: "navigation.introduction.homeApplianceIndustryInEurope",
				description: "",
			},
			{
				url: "/products",
				label: "navigation.introduction.products",
				description: "",
			},
			{
				url: "/projects",
				label: "navigation.introduction.projects",
				description: "",
			},
			{
				url: "/policy-developments-in-2024",
				label: "navigation.introduction.policyDevelopmentsIn2024",
				description: "",
			},
			{
				url: "/roadmap-to-a-fair-sustainable-and-prosperous-european-society",
				label: "navigation.introduction.roadmapToAFairSustainableAndProsperousEuropeanSociety",
				description: "",
			},
			{
				url: "/what-to-watch-in-2025",
				label: "navigation.introduction.whatToWatchIn2025",
				description: "",
			},
		],
	},
	{
		label: "navigation.pillar1.index",
		url: "/pillar/1",
		pillarNumber: 1,
		children: [
			{
				label: "navigation.pillar1.materialUseDuringTheProductionProcess",
				url: "/material-use-during-the-production-process",
				description: "",
				narrative: "Production",
			},
			{
				label: "navigation.pillar1.averageWaterConsumption",
				url: "/average-water-consumption-of-washing-machines-and-dishwashers",
				description: "",
				narrative: "Use & consumption",
			},
			{
				label: "navigation.pillar1.averageEnergyConsumption",
				url: "/average-energy-consumption-of-washing-machines-and-dishwashers",
				description: "",
				narrative: "Use & consumption",
			},
			{
				label: "navigation.pillar1.averageMaterialCompositionOfHomeAppliances",
				url: "/average-material-composition-of-home-appliances",
				description: "",
				narrative: "Material flow",
			},
			{
				label: "navigation.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances",
				url: "/quantities-of-individual-materials-used-in-home-appliances",
				description: "",
				narrative: "Material flow",
			},
			{
				label: "navigation.pillar1.averageMaterialCompositionOfLargeHomeAppliances",
				url: "/average-material-composition-of-large-home-appliances",
				description: "",
				narrative: "Material flow",
			},
			{
				label: "navigation.pillar1.averageMaterialCompositionOfSmallHomeAppliances",
				url: "/average-material-composition-of-small-home-appliances",
				description: "",
				narrative: "Material flow",
			},
			{
				label: "navigation.pillar1.routesOfRecycledPlastic",
				url: "/routes-of-recycled-plastic",
				description: "",
				narrative: "Material flow",
			},
			{
				label: "navigation.pillar1.repairOfHomeAppliances",
				url: "/repair-of-home-appliances",
				description: "",
				narrative: "Repair",
			},
			{
				label: "navigation.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices",
				url: "/evolution-of-energy-consumption-and-energy-prices",
				description: "",
				narrative: "Energy",
			},
			{
				label: "navigation.pillar1.energyConsumptionAndEnergyPricesInTheEU",
				url: "/energy-consumption-and-energy-prices-in-the-eu",
				description: "",
				narrative: "Energy",
			},
			{
				label: "navigation.pillar1.averageAnnualAdditionalSavingsForEUHouseholds",
				url: "/average-annual-additional-savings-for-eu-households",
				description: "",
				narrative: "Energy",
			},
			{
				label: "navigation.pillar1.collectionOfWEEEByEUMemberStates",
				url: "/collection-of-weee-by-eu-member-states",
				description: "",
				narrative: "Recycling",
			},
			{
				label: "navigation.pillar1.hoardingOfWeee",
				url: "/hoarding-of-weee",
				description: "",
				narrative: "Recycling",
			},
			{
				label: "navigation.pillar1.weeeFlowInTheHomeApplianceSector",
				url: "/weee-flow-in-the-home-appliance-sector",
				description: "",
				narrative: "Recycling",
			},
			{
				label: "navigation.pillar1.materialsRecoveredFromWaste",
				url: "/materials-recovered-from-waste",
				description: "",
				narrative: "Secondary raw materials",
			},
		],
	},
	{
		label: "navigation.pillar2.index",
		url: "/pillar/2",
		pillarNumber: 2,
		children: [
			{
				label: "navigation.pillar2.europeanMarketHistoricalPicture",
				url: "/historical-evolution-of-the-european-large-appliance-market",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.largeAppliancesSoldGlobally",
				url: "/large-appliances-sold-globally",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.unitsTradedInEurope",
				url: "/units-traded-in-europe",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.importAndExportOfHomeAppliancesInEuropeByContinent",
				url: "/import-and-export-of-home-appliances-in-europe-by-continent",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.top10ImportAndExportCountries",
				url: "/top-10-import-and-export-countries",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.evolutionOfImportAndExportOfHomeAppliancesInEurope",
				url: "/evolution-of-import-and-export-of-home-appliances-in-europe",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.appliaMembersManufacturingSitesInEurope",
				url: "/applia-members-manufacturing-sites-in-europe",
				description: "",
				narrative: "Market trends",
			},
			{
				label: "navigation.pillar2.patentsFiledAndGrantedForHomeAppliances",
				url: "/patents-filed-and-granted-for-home-appliances",
				description: "",
				narrative: "R&D",
			},
			{
				label: "navigation.pillar2.investmentInRAndDByEuMemberStates",
				url: "/investment-in-r-and-d-by-eu-member-states",
				description: "",
				narrative: "R&D",
			},
			{
				label: "navigation.pillar2.investmentRDvsGDP",
				url: "/investment-in-r-and-d-by-eu-member-states-as-fraction-of-gdp",
				description: "",
				narrative: "R&D",
			},
		],
	},
];
